<template>
  <div class="app-container calendar-list-container">
    <basic-container>
      <template>
        <el-tabs @tab-click="switchTab" v-model="switchStatus">
          <el-tab-pane label="信息管理" name="userManager" />
          <el-tab-pane
            label="密码管理"
            v-if="permissions.info_edit_password"
            name="passwordManager"
          />
        </el-tabs>
      </template>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              label-width="100px"
              v-if="switchStatus === 'userManager'"
              class="demo-ruleForm"
            >
              <el-form-item label="用户名" prop="username">
                <el-input
                  type="text"
                  v-model="ruleForm2.username"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realname">
                <el-input v-model="ruleForm2.realname" disabled></el-input>
              </el-form-item>

              <el-form-item label="工号" prop="staffCode">
                <el-input v-model="ruleForm2.staffCode" disabled></el-input>
              </el-form-item>
            </el-form>
            <el-form
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              label-width="100px"
              v-if="switchStatus === 'passwordManager'"
              class="demo-ruleForm"
            >
              <el-form-item label="原密码" prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm2.password"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="newpassword1">
                <el-input
                  type="password"
                  v-model="ruleForm2.newpassword1"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="newpassword2">
                <el-input
                  type="password"
                  v-model="ruleForm2.newpassword2"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm2')">
                  提交
                </el-button>
                <el-button @click="resetForm('ruleForm2')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </basic-container>
  </div>
</template>

<script>
import { updatePasswordSyncTalent } from '@/api/admin/user';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import request from '@/router/axios';

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.ruleForm2.password !== '') {
        if (value !== this.ruleForm2.newpassword1) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      switchStatus: '',
      avatarUrl: '',
      isQc: false,
      show: false,
      headers: {
        Authorization: 'Bearer ' + store.getters.access_token,
      },
      ruleForm2: {
        username: '',
        password: '',
        newpassword1: '',
        newpassword2: '',
        avatar: '',
        phone: '',
        staffCode: '',
        realname: '',
      },
      rules2: {
        password: [
          {
            required: true,
            min: 6,
            message: '原密码不能为空且不少于6位',
            trigger: 'change',
          },
        ],
        newpassword1: [
          { required: false, min: 6, message: '不少于6位', trigger: 'change' },
        ],
        newpassword2: [
          { required: false, validator: validatePass, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.ruleForm2.username = this.userInfo.username;
    this.ruleForm2.phone = this.userInfo.phone;
    this.ruleForm2.realname = this.userInfo.realname;
    this.ruleForm2.staffCode = this.userInfo.staffCode;
    if (this.$route.query.tabId === '2') {
      this.switchStatus = 'passwordManager';
    } else {
      this.switchStatus = 'userManager';
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      roles: (state) => state.user.roles,
    }),
    ...mapGetters(['permissions']),
  },
  methods: {
    switchTab(tab, event) {
      this.switchStatus = tab.name;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request({
            url: '/system/user/edit',
            method: 'put',
            data: this.ruleForm2,
          })
            .then((response) => {
              if (response.data.data) {
                updatePasswordSyncTalent({
                  password: this.ruleForm2.newpassword1,
                }).then((res) => {
                  this.$notify({
                    title: '成功',
                    message: '修改成功',
                    type: 'success',
                    duration: 2000,
                  });
                });
                return;
                // 修改密码之后强制重新登录
                if (this.switchStatus === 'passwordManager') {
                  this.$store.dispatch('LogOut').then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                }
              } else {
                this.$notify({
                  title: '失败',
                  message: response.data.msg,
                  type: 'error',
                  duration: 2000,
                });
              }
            })
            .catch(() => {
              this.$notify({
                title: '失败',
                message: '修改失败',
                type: 'error',
                duration: 2000,
              });
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px !important;
  color: #8c939d !important;
  width: 178px !important;
  height: 178px !important;
  line-height: 178px !important;
  text-align: center !important;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
